"use client";

import React, { useEffect, useRef, useState } from "react";
import { Circle } from "lucide-react";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
const collectedData = ["Dati anagrafici e di contatto forniti volontariamente durante la registrazione, come nome, cognome, indirizzo email e numero di telefono.", "Informazioni relative agli ordini, alle preferenze di acquisto e allo storico delle transazioni effettuate sul nostro portale.", "Dati di navigazione raccolti automaticamente tramite cookie e tecnologie di tracciamento per migliorare l'esperienza utente.", "Comunicazioni e corrispondenza intercorsa con il nostro servizio di assistenza clienti per richieste o supporto."];
export default function RaccoltaDeiDatiPersonali() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section id="raccolta-dei-dati-personali" className="bg-secondary py-[100px] px-4 md:px-8">
      <div className="mx-auto max-w-7xl">
        <div ref={ref} className={`bg-card rounded-lg p-8 md:p-12 shadow-sm transition-opacity duration-600 ease-in-out ${isVisible ? "opacity-100" : "opacity-0"}`}>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
            {}
            <div className="md:col-span-4 flex flex-col gap-4">
              <span className="font-serif italic text-ring text-xl tracking-wide">
                Informativa sulla Privacy
              </span>
              <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground leading-tight">
                Raccolta dei Dati Personali
              </h2>
            </div>

            {}
            <div className="md:col-span-8 flex items-center">
              <ul className="space-y-6">
                {collectedData.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-4">
                    <Circle className="w-6 h-6 text-ring shrink-0 stroke-[1.5] mt-0.5" />
                    <p className="font-sans text-foreground text-base md:text-lg leading-relaxed">
                      {item}
                    </p>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}